import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { VolunteerOrgActivity } from "../volunteer-org-activity";
import { VolunteerOrgActivityDomainEntityConfig } from "./config";
import { VolunteerOrgActivityDomainFilters } from "./filters";
import { VolunteerOrgActivityDomainMethods } from "./methods";

@HyperEntity(
  "volunteer-org-activity-domain",
  VolunteerOrgActivityDomainEntityConfig,
)
export class VolunteerOrgActivityDomain extends extender(
  VolunteerOrgActivityDomainFilters,
  VolunteerOrgActivityDomainMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ caption: "שם" })
  name = "";

  @Fields.boolean({ dbName: "is_active", caption: "פעיל" })
  isActive = true;

  @Fields.integer({ dbName: "sort_order", caption: "סדר" })
  sortOrder = 0;

  @Relations.toMany(() => VolunteerOrgActivity, {
    field: "domainId",
  })
  activities?: VolunteerOrgActivity[];

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
